import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    vehicles: null,
    loading: false,
    error: null,
    search: '',
    pageNumber: 1,
    pageSize: 10,
    isBlackListed: true,
    filteredColumns: []
};
const setLoading = () => ({ type: 'VEHICLE_LOADING' });
export const fetchVehicles = createAsyncThunk('blacklistWhitelistVehicle/fetchVehicles', async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const { search, pageNumber, pageSize, isBlackListed, filteredColumns } = state.blacklistWhitelistVehicle;
    const params = {
        isBlackListed,
        searchString: search,
        pageNumber,
        pageSize,
        filteredColumns
    };
    try {
        const response = await itwApi.post('VehicleDetail/get-vehicle-detail', params);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch vehicles');
    }
});
export const createVehicle = (vehicleData) => async (dispatch) => {
    try {
        dispatch(setLoading());
        const response = await itwApi.post('/VehicleDetail', vehicleData);
        if (response.data.isSuccess) {
            dispatch({
                type: 'CREATE_VEHICLE',
                payload: response.data
            });
            return response.data;
        }
        else {
            dispatch({
                type: 'CREATE_VEHICLE_FAILURE',
                payload: response.data
            });
            return response.data;
        }
    }
    catch (error) {
        const typedError = error;
        dispatch({
            type: 'VEHICLE_ERROR',
            payload: typedError.message
        });
    }
};
export const vehicleReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SAVE_VEHICLE_REQUEST':
            return { ...state, loading: true };
        case 'SAVE_VEHICLE_SUCCESS':
            return { ...state, loading: false, vehicle: action.payload };
        case 'SAVE_VEHICLE_FAILURE':
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};
export const vehicleSlice = createSlice({
    name: 'blacklistWhitelistVehicle',
    initialState,
    reducers: {
        clearVehicles: (state) => {
            state.vehicles = null;
        },
        setSearch: (state, action) => {
            state.search = action.payload;
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setIsBlackListed: (state, action) => {
            state.isBlackListed = action.payload;
        },
        clearFilters: (state) => {
            state.filteredColumns = [];
        },
        setAddFilter: (state, action) => {
            if (action.payload.length === 0) {
                state.filteredColumns = [];
                return;
            }
            state.filteredColumns = action.payload.filter((filter) => !action.payload.some((newFilter) => newFilter.key === filter.key && newFilter.value === ''));
            state.filteredColumns.forEach((newFilter) => {
                const existingIndex = action.payload.findIndex((filter) => filter.key === newFilter.key);
                if (existingIndex !== -1) {
                    state.filteredColumns[existingIndex].value = newFilter.value;
                }
                else {
                    state.filteredColumns.push(newFilter);
                }
            });
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVehicles.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchVehicles.fulfilled, (state, action) => {
            state.loading = false;
            state.vehicles = action.payload;
        })
            .addCase(fetchVehicles.rejected, (state, action) => {
            state.loading = false;
            state.error = null;
        });
    }
});
export const { setAddFilter, clearVehicles, setSearch, setPageNumber, setPageSize, setIsBlackListed, clearFilters } = vehicleSlice.actions;
export default vehicleSlice.reducer;
